import {useMutation, useQueryClient} from '@tanstack/react-query';
import {archiveEventCategory} from 'src/data/services/eventCategoriesService';
import {EVENT_CATEGORIES_QUERY_KEY} from 'src/app/hooks/event-categories/useEventCategories';
import Toaster from 'src/app/utilities/helpers/Toaster';
import {parseErrors} from 'src/app/utilities/helpers/errors';

const useArchiveEventCategory = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: archiveEventCategory,
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [EVENT_CATEGORIES_QUERY_KEY],
            });
        },
        onError: (errors) => Toaster.toastErrors(parseErrors(errors)),
    });
};

export default useArchiveEventCategory;
